
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function ProjectTotalCarbonCreditsHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '200px',
				minWidth: '200px',
				maxWidth: '200px'
			}}>
			Total Carbon Credits
		</StickyHeader>
	)
}

export function ProjectTotalCarbonCreditsFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CarbonTotalCreditsIssuedValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonTotalCreditsIssuedValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.CarbonTotalCreditsIssued ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonTotalCreditsIssued: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function ProjectTotalCarbonCreditsContent({ ppn }: { ppn: EditedParticipation }) {
	return (

		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CarbonTotalCreditsIssuedValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CarbonTotalCreditsIssued}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}